<template>
  <div class="container">
    <li class="return">
      <span @click="back"><i class="el-icon-arrow-left"></i>返回</span>
      <el-divider direction="vertical"></el-divider>
      <span>添加文章</span>
    </li>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="left"
      label-width="100px"
    >
      <div>
        <el-form-item label="文章标题：" prop="title">
          <el-input
            placeholder="请输入标题"
            v-model="form.title"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="文章来源：" prop="source">
          <el-input placeholder="请输入来源" v-model="form.source"></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="封面封面：" prop="cover">
          <div class="cover">
            <label class="upload" name="file">
              <div
                class="cover"
                v-if="form.cover"
                :style="`background-image:url(${$utils.fileUrl(form.cover)})`"
              ></div>
              <input type="file" id="file" @change="upload" />
              <span v-if="!form.cover">点击添加封面</span>
            </label>
            <span>图片比例16:9 推荐1920*1080</span>
          </div>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="文章说明：" prop="content">
          <div class="editor">
            <editor :html="form.content" @change="change"></editor>
            <li class="length">{{ length }}/10000</li>
          </div>
        </el-form-item>
      </div>
    </el-form>

    <li class="save-but">
      <el-button type="primary" size="small" @click="save">发布</el-button>
    </li>
  </div>
</template>

<script>
import editor from "../../../components/Editor";
export default {
  components: {
    editor,
  },
  data() {
    return {
      form: {
        title: "",
        cover: "",
        content: "",
        source: "",
        status: "",
      },
      rules: {
        title: [{ required: true, message: "请输入新闻标题", trigger: "blur" }],
        source: [{ required: true, message: "请输入来源", trigger: "blur" }],
        cover: [{ required: true, message: "请上传封面图片", trigger: "blur" }],
        content: [
          {
            required: true,
            validator: (rule, value, callback) => {
              this.checkContent(rule, value, callback);
            },
            trigger: ["blur"],
          },
        ],
      },
      length: 0,
      loading: false,
    };
  },
  methods: {
    change(data) {
      this.form.content = data;
      this.$refs["form"].validateField("content");
      this.length = this.$utils.getEditorLength(data);
    },
    // 检查手机号
    checkContent(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入文章内容"));
      } else {
        if (this.length > 10000) {
          return callback(new Error("文章内容最多10000字"));
        } else {
          callback();
        }
      }
    },
    back() {
      this.$router.go(-1);
    },
    upload(e) {
      e = e.target || e.srcElement;
      const files = e.files[0];
      if (e.value == "") {
        return;
      }

      let args = files.name.split(".");
      let nameType = args[args.length - 1];
      const fileType = ["jpg", "png"];

      if (fileType.indexOf(nameType) < 0) {
        this.$message.warning(`不支持上传${nameType}格式的文件`);
        return;
      }

      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        this.$api
          .uploadFile("2", files)
          .then((res) => {
            this.$message.success("上传成功");
            this.form.cover = res;
            e.value = "";
            this.$loading.done();
            this.loading = false;
            this.$refs["form"].validateField("cover");
          })
          .catch((err) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
          });
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitSave();
        } else {
          return false;
        }
      });
    },
    async submitSave() {
      if (!this.loading) {
        try {
          const params = {
            title: this.form.title,
            source: this.form.source,
            cover: this.form.cover,
            content: this.form.content,
            status: 1,
          };
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.operate.news.addData(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.$message.success("添加成功！");
            this.$router.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {}
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.return {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid $--border-color-base;

  span {
    cursor: pointer;
    font-size: 0.875rem;
    color: $--color-text-regular;
  }
}

.cover {
  display: flex;
  align-items: flex-end;
  .upload {
    width: 160px;
    height: 90px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: $--border-radius-base;
    border: 1px solid $--border-color-base;

    span {
      font-size: 0.75rem;
      color: $--color-text-secondary;
    }

    input {
      display: none;
    }

    .cover {
      width: 160px;
      height: 90px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  & > span {
    line-height: 20px;
    margin-left: 10px;
    font-size: 0.75rem;
    color: $--color-text-secondary;
  }
}

.el-input {
  max-width: 400px;
  :deep(input) {
    padding-right: 50px;
  }
}

.save-but {
  max-width: 1100px;
  text-align: center;
}

.editor {
  max-width: 839px;
  margin-bottom: -20px;
  .length {
    line-height: 20px;
    text-align: right;
    color: $--color-text-regular;
  }
}
</style>